<template>
  <el-row>
    <el-col :span="24">
      <div class="gs-header">
        <h2>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ name: 'home' }"><i class="fa fa-home"></i></el-breadcrumb-item>
            <el-breadcrumb-item v-for="(page, index) in breadcrumbs" :key="index" :to="page.route">{{ page.title
            }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="title"><span v-html="title"></span></el-breadcrumb-item>
          </el-breadcrumb>
        </h2>

        <div>
          <slot></slot>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {

  name: 'GsHeader',
  props: {
    title: {
      type: String,
      default: null
    },
    breadcrumbs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.gs-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 2px 85px 2px;
  border-bottom: 1px solid #dedede;
}

.gs-header h2 {
  color: #4a4a4a;
  display: block;
}
</style>



// WEBPACK FOOTER //
// GsHeader.vue?2629d340